"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var reactstrap_1 = require("reactstrap");

var ColOverride = styled_components_1.default(reactstrap_1.Col)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media only screen and (max-width:767px) {\n    padding: ", ";\n  }\n"], ["\n  @media only screen and (max-width:767px) {\n    padding: ", ";\n  }\n"])), function (props) {
  return props.noPaddingMobile ? '0 !important' : 'inherit';
});
exports.default = ColOverride;
var templateObject_1;